import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FilterListOutlinedIcon from '@material-ui/icons/FilterListOutlined';
import Button from '../Basic/Button';

const useStyles = makeStyles(() => ({
  root: {
    zIndex: 50,
    marginLeft: 5,
    height: 20,
    width: 22,
    minWidth: 'initial',
    padding: 0,

    '&.isNotActive': {
      color: '#8e8e8e',
    },

    '& svg': {
      fontSize: '1.25rem',
    },
  },
}));

const ViewFilterButton = ({ className = '', isActive, disabled, onClick }) => {
  const classes = useStyles();

  function modifiedOnClick(e) {
    e.stopPropagation();

    if (onClick) {
      onClick(e);
    }
  }

  return (
    <Button
      className={`ViewFilterButton ${classes.root} ${
        isActive ? 'isActive' : 'isNotActive'
      } ${className}`}
      color="primary"
      disabled={disabled}
      size="small"
      onClick={modifiedOnClick}
      variant={isActive ? 'contained' : 'text'}
      disableElevation
    >
      <FilterListOutlinedIcon />
    </Button>
  );
};

export default ViewFilterButton;
